import cn from "classnames"
import React from "react"
import { useTranslation } from "react-i18next"

import { useExportMagLang } from "~/components/LanguageProvider/LanguageProvider"

import styles from "./index.module.css"

const Facebook = (
  <svg fill="none" height="45" viewBox="0 0 60 45" width="60" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.6705 23.8366H24.2275V42.3387C24.2275 42.704 24.5276 43 24.898 43H32.6246C32.9949 43 33.2951 42.704 33.2951 42.3387V23.9238H38.5337C38.8743 23.9238 39.1609 23.6717 39.1998 23.338L39.9954 16.5264C40.0173 16.339 39.9571 16.1513 39.83 16.0108C39.7027 15.87 39.5206 15.7895 39.3295 15.7895H33.2953V11.5197C33.2953 10.2325 33.998 9.57984 35.3841 9.57984C35.5817 9.57984 39.3295 9.57984 39.3295 9.57984C39.6999 9.57984 40 9.28372 40 8.91855V2.66618C40 2.30089 39.6999 2.00489 39.3295 2.00489H33.8922C33.8539 2.00304 33.7687 2 33.6432 2C32.6998 2 29.4205 2.18265 26.8302 4.53287C23.9601 7.1373 24.3591 10.2557 24.4544 10.7964V15.7894H19.6705C19.3001 15.7894 19 16.0854 19 16.4506V23.1752C19 23.5405 19.3001 23.8366 19.6705 23.8366Z"
      fill="black"
    />
  </svg>
)

const Instagram = (
  <svg fill="none" height="45" viewBox="0 0 60 45" width="60" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M29.621 40.5484V40.5431C32.6943 40.5431 35.7683 40.5893 38.8405 40.5329C44.1144 40.4363 47.3113 37.195 47.3294 31.9547C47.3502 25.9791 47.3498 20.0033 47.3294 14.0277C47.3109 8.67203 44.1399 5.35271 38.7873 5.27343C32.6422 5.18262 26.4937 5.18154 20.3486 5.27469C15.1035 5.35433 12.0102 8.38537 11.9359 13.5118C11.8458 19.7265 11.842 25.9445 11.9415 32.1588C11.9986 35.7343 13.4931 38.592 17.0577 39.8887C18.2453 40.3206 19.5794 40.4808 20.8541 40.5199C23.7739 40.6098 26.6984 40.5484 29.621 40.5484M8.08507 12.9546C8.38589 6.26834 13.2731 1.52319 20.0082 1.41095C26.393 1.30447 32.7818 1.3151 39.1672 1.39834C46.1572 1.4895 51.1079 6.40581 51.242 13.455C51.3626 19.7876 51.3648 26.1262 51.2427 32.4588C51.1039 39.6544 46.0608 44.5574 38.8571 44.6255C32.7122 44.6835 26.5659 44.6765 20.4208 44.6264C14.2663 44.5761 9.62948 40.9929 8.37866 35.3491C8.12123 34.188 8.04656 32.9706 8.02668 31.7768C7.97805 28.8655 8.01077 25.9526 8.01077 23.0402C8.05868 19.678 7.93412 16.3101 8.08507 12.9546Z"
      fill="black"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M36.4271 22.6493C36.5122 18.7447 33.4444 15.4761 29.6302 15.4075C25.8463 15.3392 22.6439 18.4559 22.5612 22.2869C22.4751 26.2751 25.4597 29.4916 29.3635 29.6179C33.1349 29.7399 36.3415 26.5764 36.4271 22.6493M29.5928 11.5527C35.4971 11.5545 40.3928 16.5619 40.3775 22.5835C40.3619 28.6307 35.5197 33.4694 29.4893 33.4634C23.6079 33.4575 18.757 28.5442 18.7637 22.5996C18.7703 16.4472 23.5701 11.5509 29.5928 11.5527"
      fill="black"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M43.2017 11.0509C43.2067 12.5051 42.1617 13.6023 40.7505 13.6246C39.2993 13.6477 38.1778 12.5367 38.1729 11.0716C38.1683 9.62355 39.3245 8.44877 40.7311 8.47252C42.1246 8.49574 43.1966 9.61462 43.2017 11.0509"
      fill="black"
      fillRule="evenodd"
    />
  </svg>
)

const Twitter = (
  <svg fill="none" height="45" viewBox="0 0 60 45" width="60" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.9075 41.3C38.6142 41.3 47.7559 27.4457 47.7559 15.4516C47.7559 15.0619 47.7559 14.6721 47.7382 14.2823C49.5098 13.0067 51.0512 11.3945 52.2736 9.56973C50.6437 10.2961 48.8898 10.7745 47.0472 11.0048C48.9252 9.88863 50.3602 8.09926 51.0512 5.97328C49.2972 7.01855 47.3484 7.76265 45.2756 8.17013C43.6102 6.39847 41.2539 5.30005 38.6496 5.30005C33.6358 5.30005 29.561 9.37485 29.561 14.3886C29.561 15.0973 29.6496 15.7882 29.7913 16.4615C22.2441 16.0894 15.5472 12.4575 11.065 6.9654C10.2854 8.31186 9.84252 9.87091 9.84252 11.5363C9.84252 14.6898 11.4547 17.4713 13.8819 19.1012C12.3937 19.0481 10.9941 18.6406 9.77165 17.9674C9.77165 18.0028 9.77165 18.0382 9.77165 18.0914C9.77165 22.4851 12.9075 26.1701 17.0531 27.0028C16.2913 27.2154 15.4941 27.3217 14.6614 27.3217C14.0768 27.3217 13.5098 27.2686 12.9606 27.1623C14.1122 30.7764 17.4783 33.3985 21.4469 33.4693C18.3287 35.9142 14.4134 37.367 10.1614 37.367C9.43504 37.367 8.70866 37.3315 8 37.243C12.0039 39.7941 16.7874 41.3 21.9075 41.3"
      fill="black"
    />
  </svg>
)

const Vimeo = (
  <svg fill="none" height="45" viewBox="0 0 60 45" width="60" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M33.1595 16.8487C33.3179 15.5688 33.7328 14.4403 34.3562 13.4103C36.3034 10.1933 39.1186 8.33953 42.8224 8.02854C46.3465 7.73274 48.8012 10.0232 48.8728 13.642C48.9286 16.4559 48.0795 19.072 47.0063 21.6106C44.7558 26.9338 41.3022 31.3839 37.2912 35.416C35.6538 37.0618 33.9293 38.6058 32.0477 39.9568C29.8379 41.5433 27.7633 41.4022 25.7539 39.5418C24.6451 38.5153 23.8723 37.2654 23.3764 35.8254C21.8772 31.4725 20.6809 27.022 19.2983 22.6316C18.8636 21.2507 18.4432 19.8638 17.8945 18.524C17.4472 17.431 16.9593 17.2184 15.8393 17.5982C15.0659 17.8604 14.3756 18.2834 13.7251 18.7726C13.4721 18.9629 13.3174 18.9868 13.1209 18.6926C12.7396 18.1214 12.0363 17.5939 12.0011 17.0141C11.9673 16.4614 12.7473 15.9795 13.1997 15.4968C15.497 13.0465 17.8788 10.6967 20.8762 9.13101C21.8825 8.60532 22.9294 8.18806 24.0973 8.31792C25.2603 8.44742 26.0087 9.18317 26.5663 10.1577C27.5261 11.8357 27.9078 13.7092 28.2135 15.5906C28.808 19.2503 29.4929 22.8856 30.6393 26.4144C30.8465 27.0522 31.0706 27.6854 31.4259 28.256C31.9045 29.0244 32.3455 29.1064 33.0475 28.5609C33.611 28.1229 34.0519 27.5643 34.4725 26.9902C35.6711 25.354 36.6847 23.5991 37.5794 21.7755C38.1092 20.6957 38.4217 19.552 38.2005 18.3191C37.8893 16.5847 36.6211 15.7387 34.9371 16.1293C34.3328 16.2696 33.7841 16.5466 33.1595 16.8487"
      fill="black"
      fillRule="evenodd"
    />
  </svg>
)

const YouTube = (
  <svg fill="none" height="45" viewBox="0 0 60 45" width="60" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M52.6599 4.19419C55.1558 4.85129 57.1209 6.78742 57.7879 9.24613C59 13.7023 59 23 59 23C59 23 59 32.2974 57.7879 36.7542C57.1209 39.2126 55.1558 41.1487 52.6599 41.8061C48.1372 43 30 43 30 43C30 43 11.8628 43 7.3398 41.8061C4.84415 41.1487 2.87874 39.2126 2.21174 36.7542C1 32.2974 1 23 1 23C1 23 1 13.7023 2.21174 9.24613C2.87874 6.78742 4.84415 4.85129 7.3398 4.19419C11.8628 3 30 3 30 3C30 3 48.1372 3 52.6599 4.19419ZM38.356 23.0003L23.6102 31.2925V14.7075L38.356 23.0003Z"
      fill="black"
      fillRule="evenodd"
    />
  </svg>
)

const Behance = (
  <svg fill="none" height="45" viewBox="0 0 60 45" width="60" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.4008 7C20.9592 7 22.3801 7.13432 23.6635 7.40348C24.947 7.67238 26.047 8.11351 26.9637 8.72534C27.8803 9.33794 28.5908 10.1523 29.095 11.1683C29.5993 12.1844 29.8514 13.4391 29.8514 14.933C29.8514 16.5466 29.477 17.8911 28.7285 18.9665C27.9794 20.0421 26.8721 20.9233 25.4054 21.6107C27.4221 22.1785 28.927 23.1725 29.9203 24.591C30.9127 26.0106 31.4104 27.7214 31.4104 29.7228C31.4104 31.3362 31.0896 32.7333 30.4475 33.9138C29.8061 35.0944 28.9423 36.0578 27.8582 36.8037C26.7732 37.5512 25.5355 38.1035 24.1454 38.4627C22.7466 38.8219 21.306 39.0025 19.8597 39H4V7H19.4008ZM18.4842 19.9528C19.7676 19.9528 20.8216 19.6541 21.6469 19.0563C22.4719 18.4589 22.8843 17.4876 22.8843 16.1431C22.8843 15.3965 22.7469 14.7836 22.4719 14.3056C22.1969 13.8278 21.8303 13.4536 21.3719 13.1852C20.9135 12.9161 20.3863 12.7301 19.7905 12.6248C19.1777 12.519 18.5565 12.4665 17.9341 12.4681H11.1963V19.953H18.4842V19.9528ZM18.8965 33.5321C19.599 33.5321 20.2716 33.4647 20.9132 33.3304C21.5548 33.1958 22.1199 32.9717 22.6093 32.6578C23.0977 32.3446 23.4874 31.9185 23.778 31.3804C24.0681 30.8429 24.2133 30.1558 24.2133 29.3188C24.2133 27.6761 23.7393 26.5033 22.7925 25.8009C21.8449 25.0988 20.5921 24.7475 19.0339 24.7475H11.1963V33.5316L18.8965 33.5321V33.5321ZM40.4664 32.86C41.4442 33.7871 42.8499 34.2493 44.6834 34.2493C45.9968 34.2493 47.1278 33.9288 48.0748 33.2859C49.0221 32.6443 49.6029 31.964 49.8167 31.2466H55.5461C54.6298 34.0252 53.2235 36.0126 51.3294 37.2072C49.4343 38.4026 47.1424 39 44.4537 39C42.5897 39 40.9087 38.7087 39.4117 38.1259C37.9141 37.5435 36.6457 36.7142 35.6076 35.6386C34.5684 34.5632 33.7663 33.2793 33.2009 31.7847C32.6353 30.2911 32.3533 28.6474 32.3533 26.8547C32.3533 25.1222 32.6428 23.5088 33.2241 22.0147C33.804 20.5211 34.6288 19.2288 35.6994 18.1376C36.7682 17.0475 38.0444 16.1884 39.5267 15.5608C41.0084 14.9332 42.6509 14.6198 44.4539 14.6198C46.4708 14.6198 48.2276 15.0006 49.7254 15.7626C51.2222 16.5242 52.4523 17.5487 53.4153 18.8324C54.3777 20.1174 55.0724 21.5817 55.5011 23.2244C55.9289 24.868 56.0811 26.5858 55.9596 28.3785H38.8627C38.954 30.4397 39.4879 31.9343 40.4664 32.86V32.86ZM47.823 20.6697C47.044 19.8335 45.8594 19.4147 44.271 19.4147C43.2319 19.4147 42.3689 19.587 41.6815 19.9301C40.9938 20.2743 40.4435 20.6992 40.0309 21.2075C39.6188 21.7158 39.3279 22.2538 39.1603 22.8209C38.992 23.3887 38.8926 23.8967 38.8622 24.3447H49.4501C49.1447 22.7311 48.6025 21.5064 47.823 20.6697V20.6697ZM37.7507 8.62485H50.9797V12.2114H37.7507V8.62485Z"
      fill="black"
    />
  </svg>
)

const LinkedIn = (
  <svg fill="none" height="45" viewBox="0 0 60 45" width="60" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 7.18182C11 5.96967 11.4279 4.96967 12.2838 4.18182C13.1396 3.39393 14.2523 3 15.6216 3C16.9666 3 18.0547 3.38785 18.8861 4.16364C19.7419 4.96364 20.1699 6.00604 20.1699 7.29091C20.1699 8.45455 19.7542 9.42422 18.9228 10.2C18.0669 11 16.9421 11.4 15.5483 11.4H15.5116C14.1667 11.4 13.0785 11 12.2471 10.2C11.4157 9.4 11 8.39393 11 7.18182ZM11.4768 39V14.7091H19.6197V39H11.4768ZM24.1313 39H32.2741V25.4364C32.2741 24.5879 32.372 23.9333 32.5676 23.4727C32.9099 22.6485 33.4295 21.9515 34.1264 21.3818C34.8234 20.8121 35.6975 20.5273 36.749 20.5273C39.4878 20.5273 40.8571 22.3576 40.8571 26.0182V39H49V25.0727C49 21.4848 48.1442 18.7636 46.4324 16.9091C44.7207 15.0545 42.4588 14.1273 39.6467 14.1273C36.4923 14.1273 34.0347 15.4727 32.2741 18.1636V18.2364H32.2375L32.2741 18.1636V14.7091H24.1313C24.1802 15.4848 24.2046 17.8969 24.2046 21.9455C24.2046 25.9939 24.1802 31.6788 24.1313 39Z"
      fill="black"
    />
  </svg>
)

const socials = [
  // {
  //   name: "facebook",
  //   img: Facebook,
  //   href: "https://www.facebook.com/BeaversBrothers",
  // },
  {
    name: "vimeo",
    img: Vimeo,
    href: "https://vimeo.com/beaversbrothersteam",
    href_en: "https://vimeo.com/beaversbrothers",
  },
  // {
  //   name: "instagram",
  //   img: Instagram,
  //   href: "https://instagram.com/beaversbrothers",
  // },
  // {
  //   name: "twitter",
  //   img: Twitter,
  //   href: "https://twitter.com/BeaversBrothers",
  // },
  // {
  //   name: "youtube",
  //   img: YouTube,
  //   href: "https://www.youtube.com/channel/UCm-JKBMuLQdCLbY8wdMlMhw",
  // },
  {
    name: "behance",
    img: Behance,
    href: "https://www.behance.net/BeaversBrothers",
  },
  {
    name: "linkedin",
    img: LinkedIn,
    href: "https://www.linkedin.com/company/3832405",
  },
]

export const SocialIcons = ({ isOnDark, classNameWraper, classNameIcon }) => {
  const { i18n } = useTranslation()
  const { exportMagLang } = useExportMagLang()
  const currLang = exportMagLang ? exportMagLang : i18n.language

  return (
    <div className={cn(styles.Wrapper, classNameWraper)}>
      {socials
        .filter((social) => {
          if (currLang === "en") {
            if (
              social.name === "vimeo" ||
              social.name === "behance" ||
              social.name === "linkedin"
            ) {
              return true
            }
          } else {
            if (social.name !== "linkedin" && social.name !== "behance") {
              return true
            }
          }
        })
        .map((social, i) => (
          <a
            key={i}
            className={cn(styles.Icon, classNameIcon, { [styles.IconOnDark]: isOnDark })}
            href={currLang === "en" && social.name === "vimeo" ? social.href_en : social.href}
            rel="noopener noreferrer"
            target="_blank"
          >
            {social.img}
          </a>
        ))}
    </div>
  )
}
